import { type SvgProps, SvgWrapper } from '../utils';

export function BarChartBoxedIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M2.25 19V3C2.25 2.58579 2.58579 2.25 3 2.25C3.41421 2.25 3.75 2.58579 3.75 3V19C3.75 19.3315 3.88179 19.6494 4.11621 19.8838C4.35063 20.1182 4.66848 20.25 5 20.25H21C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H5C4.27065 21.75 3.57139 21.4601 3.05566 20.9443C2.53994 20.4286 2.25 19.7293 2.25 19Z" />
      <path d="M17.25 17V9C17.25 8.58579 17.5858 8.25 18 8.25C18.4142 8.25 18.75 8.58579 18.75 9V17C18.75 17.4142 18.4142 17.75 18 17.75C17.5858 17.75 17.25 17.4142 17.25 17Z" />
      <path d="M12.25 17V5C12.25 4.58579 12.5858 4.25 13 4.25C13.4142 4.25 13.75 4.58579 13.75 5V17C13.75 17.4142 13.4142 17.75 13 17.75C12.5858 17.75 12.25 17.4142 12.25 17Z" />
      <path d="M7.25 17V14C7.25 13.5858 7.58579 13.25 8 13.25C8.41421 13.25 8.75 13.5858 8.75 14V17C8.75 17.4142 8.41421 17.75 8 17.75C7.58579 17.75 7.25 17.4142 7.25 17Z" />
    </SvgWrapper>
  );
}
